// 依頼編集モード
export enum ReceptionEditKinds {
  None = 0,
  Create = 1,
  TempEdit = 2,
  Edit = 3,
}
